<router-outlet></router-outlet>
@if (showNotificationPrompt) {
<div class="fixed top-4 right-4 bg-white shadow-lg rounded-lg p-4 flex flex-col gap-4 z-50">
    <span>Receive updates about church events?</span>
    <div class="flex flex-row gap-2">
        <btn-text label="Later" (click)="dismissPrompt()"></btn-text>
        <app-btn-action label="Enable" (click)="enableNotifications()"></app-btn-action>
    </div>
</div>
}